<template>
  <div>
    <h1 class="title mb-4">
      {{ $t("AccountPage.UserBasicInfo.title") + (username ?? "") }}
    </h1>
    <div class="d-flex flex-column align-start ga-2">
      <UserInfoItem
        v-for="detail in details"
        :key="detail.key"
        :labelText="detail.key"
        :icon="detail.icon"
        :value="detail.value"
      />
    </div>
  </div>
</template>

<script>
import UserInfoItem from "./UserInfoItem.vue";
export default {
  components: { UserInfoItem },
  props: {
    username: {
      type: String,
    },
    details: {
      type: Array,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.title {
  font-size: $largTextSize;
  font-weight: 700;
}
</style>
